import { OnyxAddressType } from '@onyx/angular';
import { OrderPointType } from '../../../dashboard/orders/common/enums/order-point-type';
import type { TransitPoint } from '../../interfaces/transit/transit-point';

export const TRAINS = {
  /* Germany */
  freiburg: {
    id: 'freiburg',
    type: OrderPointType.TRAIN,
    name: 'Freiburg',
    address: {
      label: 'Hermann-Mitsch-Straße 1, 79108 Freiburg im Breisgau, DE',
      street: 'Hermann-Mitsch-Straße',
      houseNumber: '1',
      apartmentNumber: null,
      zipCode: '79108',
      city: 'Freiburg im Breisgau',
      countryCode: 'de',
      coordinates: {
        latitude: 48.01696144823571,
        longitude: 7.841093835466691,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Hermann-Mitsch-Straße 1',
    },
    phone: null,
  },

  /* Italy */
  novara: {
    id: 'novara',
    type: OrderPointType.TRAIN,
    name: 'Novara',
    address: {
      label: 'Via Alessandro Sozzetti 7, 28100 Novara, IT',
      street: 'Via Alessandro Sozzetti',
      houseNumber: '7',
      apartmentNumber: null,
      zipCode: '28100',
      city: 'Novara',
      countryCode: 'it',
      coordinates: {
        latitude: 45.46451535478475,
        longitude: 8.645083646848773,
      },
      type: OnyxAddressType.CUSTOM,
      name: 'Via Alessandro Sozzetti, 7',
    },
    phone: null,
  },
} as const satisfies Record<TransitPoint['id'], TransitPoint>;
